export type NavigationMode = 'discovery' | 'complete'

const STORAGE_KEY = 'doit-navigation-mode'

/** `identity` doit désormais inclure le workspace (`organisation:workspace:user`) —
 * la préférence est persistée par workspace côté serveur depuis v030-po-auth-02 ;
 * une identité qui ne le porterait pas partagerait à tort le cache entre deux
 * espaces de travail du même utilisateur. */
export function navigationModeStorageKey(identity: string): string {
  return `${STORAGE_KEY}:${identity || 'anonymous'}`
}

// DEFAUT = `complete`, inverse le 2026-09-05 sur decision de l'utilisateur. Le
// vocabulaire (discovery/complete) a ete realigne le 2026-09-06 sur le contrat
// AUTH-02A adjuge : `decouverte`/`complet` ne sont plus des valeurs acceptees,
// ni cote serveur ni cote client — pas des alias, un vocabulaire remplace.
//
// Le defaut precedent etait `discovery`, qui n'affiche que les entrees
// `essentiel: true` — 11 sur 28. Consequence mesuree : l'utilisateur ouvrait
// l'application et voyait « une poignee d'ecrans », concluait qu'il n'y avait
// aucune fonctionnalite, alors que les 17 autres etaient routees et
// fonctionnelles derriere un basculement niche dans le menu utilisateur.
//
// UN MODE DECOUVERTE QUI NE SE DECLARE PAS EST INDISCERNABLE D'UN PRODUIT SANS
// FONCTIONNALITES. Le cout de se tromper n'est pas symetrique : trop montrer
// coute une barre laterale chargee, trop cacher coute la croyance que le
// produit est vide. On montre, et `discovery` devient un choix explicite.
//
// Audit du 2026-10-09 (AUD-UX-07, AUD-CRAWL-P-NAV-1) : ce defaut vaut pour TOUTE
// preference illisible — stockage qui leve, aucun projet, GET en cours ou en
// erreur — et non pour la seule cle absente. Les replis sur `discovery` qui
// subsistaient masquaient 21 a 27 entrees a des comptes qui n'avaient rien choisi.
export const MODE_NAVIGATION_PAR_DEFAUT: NavigationMode = 'complete'

function modeValide(value: string | null): NavigationMode {
  return value === 'discovery' ? 'discovery' : MODE_NAVIGATION_PAR_DEFAUT
}

function modeStocke(value: string | null): value is NavigationMode {
  return value === 'complete' || value === 'discovery'
}

export function lireModeNavigation(identity = ''): NavigationMode {
  return lireModeNavigationAvecPresence(identity).mode
}

export function lireModeNavigationAvecPresence(identity = ''): {
  mode: NavigationMode
  present: boolean
} {
  // Rendu serveur / absence de window : meme defaut que ci-dessus, sinon le
  // premier rendu masquerait 17 entrees avant l'hydratation.
  if (typeof window === 'undefined') return { mode: MODE_NAVIGATION_PAR_DEFAUT, present: false }
  try {
    const raw = window.localStorage.getItem(navigationModeStorageKey(identity))
    return { mode: modeValide(raw), present: modeStocke(raw) }
  } catch {
    // Stockage illisible (navigation privee, donnees de site bloquees) : aucune preference
    // n'a ete LUE, donc aucune n'a ete choisie — le defaut produit (AUD-UX-07).
    return { mode: MODE_NAVIGATION_PAR_DEFAUT, present: false }
  }
}

export function sauvegarderModeNavigation(mode: NavigationMode, identity = ''): void {
  if (typeof window === 'undefined') return
  try { window.localStorage.setItem(navigationModeStorageKey(identity), mode) } catch { /* repli mémoire côté hook */ }
}

export function supprimerModeNavigation(identity = ''): void {
  if (typeof window === 'undefined') return
  try { window.localStorage.removeItem(navigationModeStorageKey(identity)) } catch { /* repli mémoire côté hook */ }
}
